// extracted by mini-css-extract-plugin
export var container = "X1bn0";
export var unreadBar = "Es7y_";
export var unreadBarGrow = "lTLPj";
export var unreadBarHoverTreatmentMLItem = "E8Ubl";
export var unreadBarHoverTreatmentMLItemPart = "Hhkf_";
export var unreadBarItemPart = "YhZ1Q";
export var unreadBarUnread = "OscII";
export var unreadBarUnreadItemPart = "MLesg";